import { InfoPopover } from '@/components/info-popover/info-popover';
import { Flex, Text } from '@cmpsr/components';

type RiskAnalysisCardItemProps = {
  title: React.ReactNode;
  value: string;
  popoverContent: string;
  badgeBgColor: string;
  badgeTextColor: string;
};

export default function RiskAnalysisCardItem(props: RiskAnalysisCardItemProps) {
  return (
    <Flex flexDir="column" gap={2}>
      <Flex justifyContent="center" background={props.badgeBgColor} py={2} px={5} borderRadius="radii-1">
        <Text color={props.badgeTextColor} variant="text-body-large-regular" textAlign="center">
          {props.value}
        </Text>
      </Flex>
      {props.title}
      <InfoPopover popoverContent={props.popoverContent} color="white-50" iconSize="s" placement="bottom" />
    </Flex>
  );
}
